
import Vue from "vue"
import { Component, Prop, Watch } from "vue-property-decorator"

import * as Country from "@/lib/Util/Types/Common/Country"
import * as Currency from "@/lib/Util/Types/Common/Currency"
import * as Timespan from "@/lib/Util/Types/Common/Timespan"
import * as VatType from "@/lib/Util/Types/VAT/VatType"
import * as lodash from "lodash/fp"

import TooltipIcon from "@/components/Util/TooltipIcon.vue"

import router from "@/router/router"
import * as Filter from "@/store/Reports/ServicesSold/Filter"

@Component({
    components: { TooltipIcon },
})
export default class InvoiceListFilterView extends Vue {
    @Prop({ default: null }) item!: Filter.T

    timespans = Timespan.filter([
        { prefix: "2024", period: "A" },
        { prefix: "2024", period: "Q" },
        { prefix: "2024", period: "M" },
        { prefix: "2023", period: "A" },
        { prefix: "2023", period: "Q" },
        { prefix: "2023", period: "M" },
        { prefix: "2022", period: "A" },
        { prefix: "2022", period: "Q" },
        { prefix: "2022", period: "M" },
        { prefix: "Last", period: "Q" },
    ])

    countries = Country.KEYS
    currencies = Currency.KEYS
    vat_types = VatType.KEYS

    loaded = lodash.cloneDeep(this.item)

    clearing() {
        router.push({
            path: "/sections/reports/services_sold/list",
            query: Filter.getEmpty(),
        })
    }

    searching() {
        router.push({
            path: "/sections/reports/services_sold/list",
            query: this.loaded,
        })
    }

    @Watch("item", { deep: true })
    onItemChanged(nv: Filter.T) {
        this.loaded = lodash.cloneDeep(this.item)
    }
}
